import PAEditCoverages from 'edge/policycommon/pa/directives/PAEditCoverages';
import PAViewCoverages from 'edge/policycommon/pa/directives/PAViewCoverages';
import 'edge/policyjob/services/VinLookupService';
import 'edge/policyjob/app';
import 'edge/platform/widgets/time/module';

export default angular.module('edge.policycommon.pa.app', ['edge.policycommon.common.app', 'edge.policyjob.app', 'edge.platform.widgets.ui.time']).directive('gwPcPaEditCoverages', PAEditCoverages).directive('gwPcPaViewCoverages', PAViewCoverages);